/**
 * Чистит вставленный текст до одних ссылок.
 *
 * Ссылки обычно копируют вместе с окружением — заголовками тем, именами
 * аккаунтов, подписями. Разбор ниже по потоку ждёт по ссылке на строку, а
 * пустые строки значимы (см. parsePages): одна разделяет подгруппы, две и
 * больше — начинают новую страницу отчёта. Поэтому:
 *   - из строки берём все http(s)-ссылки, каждую на своей строке;
 *   - строки без ссылок выбрасываем;
 *   - число пустых строк между ссылками сохраняем как есть.
 *
 * Выброшенный текст пустые строки вокруг себя не удваивает: «пустая, заголовок,
 * пустая» — по-прежнему один разделитель, а не граница страницы.
 */
const URL_RE = /https?:\/\/[^\s<>"'()[\]]+/g;

export function extractLinks(raw: string): string {
  const out: string[] = [];
  let blanks = 0; // максимум подряд идущих пустых строк с последней ссылки
  let run = 0; // текущая серия пустых строк

  for (const line of raw.replace(/\r\n/g, '\n').split('\n')) {
    const urls = line.match(URL_RE);
    if (urls) {
      if (out.length > 0) for (let i = 0; i < blanks; i++) out.push('');
      // Хвостовая пунктуация из текста («…DU5TLq2iEci/,») в ссылку не входит.
      out.push(...urls.map((u) => u.replace(/[.,;:!?]+$/, '')));
      blanks = 0;
      run = 0;
      continue;
    }
    if (line.trim() === '') {
      run += 1;
      if (run > blanks) blanks = run;
    } else {
      run = 0; // строка текста серию обрывает, но накопленный максимум держим
    }
  }

  return out.join('\n');
}
